import { IonContent, IonImg } from '@ionic/react';
import React from 'react';

import { UiButtonBase } from '@/components/ui/ButtonBase';
import { UiTypography } from '@/components/ui/Typography';
import { useAccount } from '@/hooks/useAccount';
import { useAppModals } from '@/hooks/useAppModals';
import { useStripeV2Plans } from '@/hooks/useStripeV2Plans';
import { amplitudeModule } from '@/modules/amplitude';

import {
  ActionButtonsStyles,
  BannerContentPriceStyles,
  BannerContentStyles,
  BannerImageStyles,
  BannerStyles,
  BubberSaleLabelStyles,
  CoinsUpsaleModalStyles,
  ImageStyles,
  SubtitleStyles,
  TitleStyles,
} from './CoinsUpsale.styles';

export const CoinsUpsaleModal: React.FC<{ onClose: () => void }> = ({
  onClose,
}) => {
  const { show } = useAppModals('buyCoinsPaywall');

  const { user } = useAccount();
  const { coinsPlans } = useStripeV2Plans();

  const gender = user?.onboarding_data.gender || 'female';
  const coinPlan = coinsPlans?.[0] || null;

  const handlePresent = () => {
    amplitudeModule.logEvent('onboarding_screen', {
      seen: 'Upsale',
    });
  };

  return (
    <CoinsUpsaleModalStyles
      isOpen
      className="modal-coins-upsale"
      onDidPresent={handlePresent}
    >
      <IonContent>
        <ImageStyles>
          <IonImg src={`../assets/modal-coins-upsale/${gender}.png`} />
        </ImageStyles>

        <TitleStyles align="center" variant="headline-small" component="h1">
          Limited offer to unlock
          <br />
          the most intimate photos
        </TitleStyles>

        <SubtitleStyles
          align="center"
          variant="body-medium"
          color="neutral-black"
        >
          Use coins to style your bots in sexy outfits and unlock their most
          intimate photo sets and videos
        </SubtitleStyles>

        <BannerStyles>
          <BubberSaleLabelStyles variant="body-medium">
            SAVE 80%
          </BubberSaleLabelStyles>

          <BannerImageStyles src="../assets/icons/coins-amount-huge.png" />

          <BannerContentStyles className="banner-content">
            <UiTypography variant="title-large" transform="bold">
              {coinPlan?.label}
            </UiTypography>
            <BannerContentPriceStyles className="banner-content-price">
              <UiTypography
                variant="body-large"
                decoration="line-through"
                color="neutral-white-static"
              >
                ${coinPlan?.original_price}
              </UiTypography>
              <UiTypography
                variant="title-large"
                color="secondary-static"
                transform="bold"
              >
                ${coinPlan?.price}
              </UiTypography>
            </BannerContentPriceStyles>
          </BannerContentStyles>
        </BannerStyles>

        <ActionButtonsStyles>
          <UiButtonBase
            expand="full"
            onClick={() => {
              if (coinPlan) {
                show({
                  product: coinPlan,
                });
              }
            }}
          >
            Get intimate photo sets
          </UiButtonBase>
          <UiButtonBase expand="full" variant="text" onClick={onClose}>
            Decline the offer
          </UiButtonBase>
        </ActionButtonsStyles>
      </IonContent>
    </CoinsUpsaleModalStyles>
  );
};
